import { batch, useSignal } from "@preact/signals";
import { useEffect } from "react";
import { RequestStatus as FetcherStatus } from "../favorite-data-fetcher";
import { QueryQueueMessageStatus as QueueStatus } from "../types/api/favorite-data";
import { useInterval } from "./use-interval";
/**
 * Track how long a request has been in a given status.
 */
export function useTrackRequestStatus(status, updateInterval = 5000) {
    const duration = useSignal(0);
    const previousStatus = useSignal(status);
    const currentStatus = useSignal(status);
    function transition(previous, current) {
        return status === current && previousStatus.value === previous;
    }
    useEffect(() => {
        if (status !== previousStatus.value) {
            // When a queued or running request becomes in-flight, the fetcher is just polling for updates
            const queuedInFlight = transition(QueueStatus.Queued, FetcherStatus.InFlight);
            const runningInFlight = transition(QueueStatus.Running, FetcherStatus.InFlight);
            const checkingQueueStatus = queuedInFlight || runningInFlight;
            const queueMessageRunning = transition(QueueStatus.Queued, QueueStatus.Running);
            if (!checkingQueueStatus) {
                batch(() => {
                    previousStatus.value = currentStatus.value;
                    currentStatus.value = status;
                    if (queueMessageRunning) {
                        // Reset the loading duration when the query begins running.
                        duration.value = 0;
                    }
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status]);
    if (!status || status === FetcherStatus.Complete) {
        updateInterval = null;
    }
    useInterval(() => {
        if (updateInterval) {
            duration.value += updateInterval;
        }
    }, updateInterval);
    return {
        status: currentStatus.value,
        previous: previousStatus.value,
        duration: duration.value,
    };
}
